






























import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import LogoSelector from '@ui/LogoSelector'
import AddSponsorSetTrigger from './AddSponsorSetTrigger.coffee'

settings =
  name: 'AddSponsorSetTriggerModal'

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton, LogoSelector }
    mixins: [AddSponsorSetTrigger.trigger()]

    computed:
      canNotAdd: -> !@modal.data?.domain?.length

    methods:
      modalData: ->
        logo: null
        domain: null
        name: null
        description: null
        category_tags: []

      hiSelectBrand: (brand) ->
        @modal.data.logo = brand.logo
        @modal.data.domain = brand.domain
        @modal.data.name = brand.name

      clearBrandInfo: ->
        @modal.data.logo = null
        @modal.data.domain = null
        @modal.data.name = null
        @modal.data.description = null
        @modal.data.category_tags = []
        @$refs.logoSelector.cleanup()

    watch:
      'modal.show': ->
        @clearBrandInfo()

export default VueOptions.vue settings
